/**
  Using the Vuex plugin pattern: https://vuex.vuejs.org/en/plugins.html, 
  this plugin will fire off a gtm.trackEvent for each mutation that occurs within your app.
  It will also do a lookup on a literal object methods named after your mutation types. From those methods,
  return a object with looks up on the store.
*/

import Vue from "vue";

import { TOGGLE_LOADING, SET_META, RESET_STATE } from "@/store/mutation-types";

/*
const mutationLookup = {
  [SET_LIST]() {
    return {
      action: "Chargement inital"
    };
  },
  [CONCAT_LIST]() {
    return {
      action: "Chargement au scroll"
    };
  },
  [UPDATE_LIST_ITEM]() {
    return {
      action: "Modification"
    };
  },
  [REMOVE_LIST_ITEM]() {
    return {
      action: "Suppression"
    };
  },
  [UPDATE_DRAWER]() {
    return {
      action: "Ouverture ou fermeture du panel"
    };
  },
  [UPDATE_USER_DRAWER]() {
    return {
      action: "Ouverture ou fermeture du panel"
    };
  },
  [ERROR]() {
    return {
      action: "Erreur"
    };
  }
  // put methods here named after mutation names
  // see example below
};*/

/** 
const mutationLookup = {
  USER_LOGIN(store) {
    return { email: store.user.email }
  },
  USER_LOGOUT(store) { 
    return { email: store.user.email }
  }
}
*/

export default function gtmPlugin(store) {
  store.subscribe((m /*s*/) => {
    try {
      let mutationArray = m.type.split("/");
      let moduleName = mutationArray.slice(0, -1).join("/");
      let mutation = mutationArray[mutationArray.length - 1];

      if (
        [TOGGLE_LOADING, SET_META, RESET_STATE].includes(mutation) ||
        moduleName == "application"
      ) {
        return;
      }

      if (mutation) {
        Vue.gtm.trackEvent({
          event: "mutation",
          module: moduleName,
          action: mutation
        });
      }
    } catch (e) {
      throw new Error(`Error with gtm.trackEvent: ${e}`);
    }
  });
}
